import React, { useEffect, useState } from "react"

import Button, { type ButtonProps } from "@mui/material/Button"
import { SxProps, Theme } from "@mui/material/styles"
import { useTranslation } from "react-i18next"

import { useSnackbar } from "@providers/SnackbarProvider"

interface SupportButtonProps extends Omit<ButtonProps, "onClick"> {
  children: React.ReactNode
  sx?: SxProps<Theme>
}

const ContactSupportButton: React.FC<SupportButtonProps> = ({
  children,
  sx,
  variant = "text",
  size = "small",
  ...buttonProps
}) => {
  const { t } = useTranslation()
  const { openSnackbar } = useSnackbar()

  const [showWidget, setShowWidget] = useState(false)

  useEffect(() => {
    return () => {
      try {
        if (window.HubSpotConversations?.widget) {
          window.HubSpotConversations.widget.remove()
        }
      } catch {
        // Silently handle widget removal errors
      }
    }
  }, [])

  const handleWidgetToggle = () => {
    if (showWidget) {
      // Widget is currently visible, so hide it
      window.HubSpotConversations?.widget?.remove()
      setShowWidget(false)
    } else {
      const hubspotIsLoaded = window.HubSpotConversations?.widget
      if (hubspotIsLoaded) {
        // Widget is not currently visible, so show it
        window.HubSpotConversations?.widget?.load()
        window.HubSpotConversations?.widget?.open()

        setShowWidget(true)
      } else {
        // User can't load hubspot for some reason, possibly an ad-blocker
        openSnackbar(t("appMenu_openError"), {
          severity: "error",
          title: t("snackbar:error.title"),
        })
      }
    }
  }

  return (
    <Button
      onClick={handleWidgetToggle}
      variant={variant}
      size={size}
      sx={{ ...sx }}
      {...buttonProps} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </Button>
  )
}
export default ContactSupportButton
